import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different signin action types
*/
let initialstate = {
  isLoading: false,
  patientlist: [],
  actioncases: [],
  total: 0,
  editcase: {},
  pagination: {},
  searchText: '',
  msgList:[],
}
export default function actioncase_operations(
  state = { ...initialstate },
  action
) {
  switch (action.type) {
    case ActionType.CASES_INPROGRESS:
      return { ...state, isLoading: action.isLoading }
    case ActionType.CASES_LIST:
      
      return { ...state, isLoading: action.isLoading, ...action }
    case ActionType.CASES_PATIENT_LIST:
        return { ...state, isLoading: action.isLoading, msgList:action.msgList }  
    case ActionType.CASE_EDIT:
      return { ...state, editcase: action.data }
    case ActionType.SINGLE_MESSAGE:
      return { ...state, singleMsg: action.singleMsg }
    case ActionType.SET_PATIENT_AND_MESSAGE:
      return { ...state, patientAndMsg: action.patientAndMsg }      
    case ActionType.CASE_HEALTH_COACH_NAME_LIST:
      return { ...state, healthCoachList: action.data }
    case ActionType.CASE_PATIENT_LASTDIGIT_LIST:
      return { ...state, patientlist: action.data }
    case ActionType.CASESTATS:
      return { ...state, caseStats: action.data }
    case ActionType.LOGOUT:
      return initialstate
    default:
      return state
  }
}
